var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 319,
    height: 440,
    viewBox: "0 0 319 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6741",
    x: 0,
    y: 0,
    width: 319,
    height: 440,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6748",
    "data-name": "Rectangle 6748",
    width: 283,
    height: 404,
    rx: 10,
    transform: "translate(0.231 -0.177)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7952",
    "data-name": "Group 7952",
    transform: "translate(17.77 15.178)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.77, -15.18)",
    filter: "url(#Rectangle_6741)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6741-2",
    "data-name": "Rectangle 6741",
    width: 283,
    height: 404,
    rx: 10,
    transform: "translate(18 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7266",
    "data-name": "Path 7266",
    d: "M101.929,113.009.5,31.947V0H283.769V31.947L183.753,113.009C149.528,140.3,114.943,124.378,101.929,113.009Z",
    transform: "translate(-0.5 30.451)",
    fill: "#ff4248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7265",
    "data-name": "Path 7265",
    d: "M101.929,123.632.5,39.029V0H283.769V39.029l-100.017,84.6C149.528,150.919,114.943,135,101.929,123.632Z",
    transform: "translate(-0.5)",
    fill: "#0d1e30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOne);
export default __webpack_public_path__ + "static/media/CardOne.499f8c7f56edf84c9ff8fa2efbbd8d40.svg";
export { ForwardRef as ReactComponent };